import {homeSvg as Icon__small__homeSvg} from '../Icon__small/Icon__small--home.js'

export var home = {
  name: 'home',
  category: 'icon',
  colorable: true,
  svg: Icon__small__homeSvg,
};
